package app.nestbridge.domain.ping.service

import com.karawek.core.network.AuthMode
import app.nestbridge.domain.ping.api.PingApiClient
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesBinding
import software.amazon.lastmile.kotlin.inject.anvil.SingleIn

@SingleIn(AppScope::class)
@ContributesBinding(AppScope::class, boundType = PingService::class)
@Inject
class DefaultPingService(
    private val apiClient: PingApiClient,
) : PingService {

    override suspend fun ping(authMode: AuthMode): Map<String, String> =
        apiClient.getHeaders(authMode).toDomain().headers
}
